import { all, fork, take } from "redux-saga/effects";

import { authSaga, resetPasswordSaga } from "modules/auth";
import { accountsSaga } from "modules/bank-accounts";
import { banksSaga } from "modules/banks";
import {
  CashManagementNotificationsSaga,
  CashManagementProviderCustomerConfigsSaga,
  CashManagementProvidersSaga,
  CashManagementSaga,
} from "modules/cash-management";
import { checkoutBrandingSaga } from "modules/checkout";
import {
  blocklistSaga,
  riskOverviewSaga,
  riskRulesSaga,
} from "modules/circuit-breaker";
import { customerSaga, customersSaga } from "modules/customers";
import { reportsSaga, transactionsSaga } from "modules/transactions";
import { userManagementSaga } from "modules/user-management";
import {
  termsAndConditionsSaga,
  userSettingsSaga,
} from "modules/user-settings";

import { init } from "../store/appSlice";
import appSaga from "./app";
import notificationsSaga from "./notifications";
import valuesSaga from "./values";

export default function* root() {
  yield take(init().type);
  // Wait for rehydrate to get applied to prevent sagas from running with empty store
  yield all([
    fork(authSaga),
    fork(transactionsSaga),
    fork(accountsSaga),
    fork(userManagementSaga),
    fork(resetPasswordSaga),
    fork(customersSaga),
    fork(checkoutBrandingSaga),
    fork(valuesSaga),
    fork(notificationsSaga),
    fork(appSaga),
    fork(banksSaga),
    fork(CashManagementSaga),
    fork(CashManagementNotificationsSaga),
    fork(CashManagementProvidersSaga),
    fork(CashManagementProviderCustomerConfigsSaga),
    fork(customerSaga),
    fork(blocklistSaga),
    fork(riskRulesSaga),
    fork(riskOverviewSaga),
    fork(userSettingsSaga),
    fork(termsAndConditionsSaga),
    fork(reportsSaga),
  ]);
}
